import React, { useRef, useState } from 'react';
import { Modal, Form, Toast, Input, Button, Swiper } from 'antd-mobile';
import axios from 'axios';
import './index.less';
const list = [
  {
    img: 'https://oss.huizustore.com/9e9966fcfd194d5296937fa7b27a165f.png',
    title: '趣智数码',
    content: '全品类相机',
  },
  {
    img: 'https://oss.huizustore.com/c0d23027261c4ee2aaec281d58326e18.png',
    title: '槟恒贸易',
    content: '手机租赁',
  },
  {
    img: 'https://oss.huizustore.com/939b8338074a487583cf00fd3120e55a.png',
    title: '大胜租赁',
    content: '电脑租赁',
  },
  {
    img: 'https://oss.huizustore.com/f0e0c20fdba7417dbf569503e45b8c1d.png',
    title: '基原租赁',
    content: '平板租赁',
  },
  {
    img: 'https://oss.huizustore.com/e37a27add2bd4aadb4a81dce785a57f8.png',
    title: '融易租数码',
    content: '无人机租赁',
  },
]
function Business(props) {

  const swiper = useRef()
  const listRef = useRef()

  const [channel, setChannel] = useState(1);

  const showAsk = () => {
    Modal.show({
      content: (
        <div className="mobile-business-modal-content">
          <strong>立即咨询</strong>
          <div className="close" onClick={Modal.clear}></div>
          <img src="https://oss.huizustore.com/3ab3ba5267ca4fd688efe739112943ce.png" alt="huizu" className="ask-img" />
          <div className="ask-content">微信扫一扫，与客服经理一对一咨询开店</div>
        </div>
      ),
      closeOnMaskClick: true,
      className: "mobile-business-modal"
    })
  }

  const showModal = () => {
    Modal.show({
      content: (
        <div className="mobile-business-modal-content">
          <strong>立即预约</strong>
          <div className="close" onClick={(e) => {
            Modal.clear()
          }}></div>
          <Form layout="horizontal" mode='card' onFinish={onFinish} footer={<Button block type="submit" color="danger" style={{ width: '50%', margin: '0 auto' }}>提交</Button>}>
            <div className="form_line">
              <span>姓<div style={{ opacity: '0', display: 'inline' }}>占位</div>名：</span>
              <Form.Item name="contactName" rules={[{ required: true, message: '请输入姓名' }]}>
                <Input placeholder='请输入姓名' />
              </Form.Item>
            </div>
            <div className="form_line">
              <span>企业名称：</span>
              <Form.Item name="enterpriseName" rules={[{ required: true, message: '请输入企业名称' }]}>
                <Input placeholder='请输入企业名称' />
              </Form.Item>
            </div>
            <div className="form_line">
              <span>手机号码：</span>
              <Form.Item name="telephone" rules={[{ required: true, message: '请输入手机号码' }]}>
                <Input placeholder='请输入手机号码' />
              </Form.Item>
            </div>
            <div className="form_line">
              <span>意向类型：</span>
              <Form.Item name="categories">
                <Input placeholder='请输入意向类型' />
              </Form.Item>
            </div>
          </Form>
        </div>
      ),
      closeOnMaskClick: true,
      className: "mobile-business-modal"
    })
  }

  const submitForm = (data) => axios({
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'post',
    url: '/consumer-zhifubao/aliPay/user/submitUserConsultInfo',
    responseType: 'json',
    data
  })

  const onFinish = (values) => {
    submitForm({
      ...values,
      consultType: 1,
      consultSource: 1,
    }).then(res => {
      if (res?.data?.code === 1) {
        Modal.clear()
        Toast.show({
          icon: 'success',
          content: res.data.msg,
        })
      } else {
        Toast.show({
          icon: 'fail',
          content: res.data.msg,
        })
      }
    });
  };

  const headerChangePages = (num) => {
    window.location.href = `${window.location.origin}${window.location.pathname}?flag=${num}`
  }

  const showZulin = () => {
    Modal.show({
      content: (
        <div className="mobile-business-modal-content">
          <strong>立即租赁</strong>
          <div className="close" onClick={Modal.clear}></div>
          <img src="https://oss.huizustore.com/0c0f84be67b24fa890dbe7f13f6be59a.png" alt="huizu" className="ask-img" />
          <div className="ask-content">支付宝扫一扫，立即租赁</div>
        </div>
      ),
      closeOnMaskClick: true,
      className: "mobile-business-modal"
    })
  }

  const changePages = () => {
    const num = channel + 1
    window.open(`${window.location.origin}${window.location.pathname}?flag=${num}`)
  }

  return (
    <div className="mobileContent">
      <Swiper defaultIndex={1} indicatorProps={{ style: { "--active-dot-color": '#ED0000', '--active-dot-size': '3px', '--active-dot-border-radius': '50%' } }} allowTouchMove autoplay loop autoplayInterval={5000} className="homePage-swiper" >
        <Swiper.Item>
          <div className="mobileContent-container" onClick={() => headerChangePages(1)}>
            <div className="mobileContent-container-header" style={{ cursor: 'pointer' }}>
              <div className="mobileContent-container-header-top">
                全品类信用免押金租赁平台
              </div>
              <div className="mobileContent-container-header-center">
                为消费者和商家带来更高效更智能的租赁服务
              </div>
              <div className="mobileContent-container-header-bottom" href="lianxi">
                <a href="#lianxi">商家入驻</a>
              </div>
            </div>
          </div>
        </Swiper.Item>
        <Swiper.Item>
          <div className="mobileContent-container" >
            <div className="mobileContent-container-header" id="business-header">
              <div className="mobileContent-container-header-top">
                商家入驻
              </div>
              <div className="mobileContent-container-header-center">
                一分钟免费拥有自己的租赁店铺
              </div>
              <div className="mobileContent-container-header-bottom" href="lianxi" onClick={showModal}>
                <a href="#lianxi">立即试用</a>
              </div>
            </div>
          </div>
        </Swiper.Item>
        <Swiper.Item>
          <div className="mobileContent-container" onClick={() => headerChangePages(3)}>
            <div className="mobileContent-container-header" id="miniprogram-header" style={{ cursor: 'pointer' }}>
              <div className="mobileContent-container-header-top">
                租赁小程序
              </div>
              <div className="mobileContent-container-header-center">
                您自己品牌的独立支付宝小程序
              </div>
              <div className="mobileContent-container-header-bottom" href="lianxi">
                <a href="#lianxi">立即咨询</a>
              </div>
            </div>
          </div>
        </Swiper.Item>
        <Swiper.Item>
          <div className="mobileContent-container" onClick={() => headerChangePages(4)}>
            <div className="mobileContent-container-header" id="platform-header" style={{ cursor: 'pointer' }}>
              <div className="mobileContent-container-header-top">
                开放平台
              </div>
              <div className="mobileContent-container-header-center">
                有效帮助商家快速甄别用户资质，合理把控风险，助力稳健经营
              </div>
              <div className="mobileContent-container-header-bottom" href="lianxi">
                <a href="#lianxi">立即咨询</a>
              </div>
            </div>
          </div>
        </Swiper.Item>
        <Swiper.Item>
          <div className="mobileContent-container" onClick={() => headerChangePages(5)}>
            <div className="mobileContent-container-header" id="lock-header" style={{ cursor: 'pointer' }}>
              <div className="mobileContent-container-header-top">
                锁机服务
              </div>
              <div className="mobileContent-container-header-center">
                多种业务模式均可支持
              </div>
              <div className="mobileContent-container-header-bottom" href="lianxi">
                <a href="#lianxi">立即咨询</a>
              </div>
            </div>
          </div>
        </Swiper.Item>
      </Swiper>
      <div className="box" id="product">
        <div className="box-title">产品数据</div>
        <div className="box-des">5000＋认证租赁商 2000万＋用户数 月度订单20万＋</div>
        <div className="container ">
          <div className="data-data" style={{ marginLeft: "0" }}>
            <div className="data-span">
              <span className="data-span-font">2000<span className="data-span-unit">万+</span></span>
            </div>
            <div className="data-span1">用户数</div>
          </div>
          <div className="data-data">
            <div className="data-span">
              <span className="data-span-font">5000<span className="data-span-unit">+</span></span>
            </div>
            <div className="data-span1">商家入驻</div>
          </div>
          <div className="data-data" id="month">
            <div className="data-span">
              <span className="data-span-font">20<span className="data-span-unit">万+</span></span>
            </div>
            <div className="data-span1">月度订单</div>
          </div>

        </div>
        <div className="container1">
          <div className="data-data" style={{ marginLeft: "0" }}>
            <div className="data-span">
              <span className="data-span-font">20<span className="data-span-unit">+</span></span>
            </div>
            <div className="data-span1">覆盖省份</div>
          </div>
          <div className="data-data">
            <div className="data-span">
              <span className="data-span-font">10<span className="data-span-unit">万+</span></span>
            </div>
            <div className="data-span1">在租商品</div>
          </div>
        </div>
      </div>
      <div className="box" id="plat">
        <div className="box-title">0元入驻平台</div>
        <div className="box-des">入驻平台可享受</div>
        {/* <div className="box-header"></div> */}
        <div className="plat-content">累计入驻商家超<strong>5000家</strong></div>
      </div>
      {/* 消费者业务 */}
      <div className="consumption1">
        <div className="consumption-title">
          消费者业务
        </div>
        <hr className="hr-orange" />
        <div className="consumption-title-bottom">
          为消费者提供免押金租物服务，让生活更简单
        </div>
        <div className="consumption-content">
          <div className="consumption-item" id="video">
            <div className="consumption-item-title">宅家游戏电玩</div>
            <div className="consumption-item-btn" onClick={showZulin}>查看详情</div>
          </div>
          <div className="consumption-wide-content">
            <div className="consumption-wide-item" id="brand">
              <div className="consumption-wide-item-title">大牌手机抢先租</div>
              <div className="consumption-wide-item-btn" onClick={showZulin}>查看详情</div>
            </div>
            <div className="consumption-wide-item" id="camera">
              <div className="consumption-wide-item-title">摄影旅拍助手</div>
              <div className="consumption-wide-item-btn" onClick={showZulin}>查看详情</div>
            </div>
          </div>
          <div className="consumption-wide-content">
            <div className="consumption-wide-item" id="pad">
              <div className="consumption-wide-item-title">平板电脑合集</div>
              <div className="consumption-wide-item-btn" onClick={showZulin}>查看详情</div>
            </div>
            <div className="consumption-wide-item" id="watch">
              <div className="consumption-wide-item-title">耳机手表配饰</div>
              <div className="consumption-wide-item-btn" onClick={showZulin}>查看详情</div>
            </div>
          </div>
          <div className="consumption-item" id="computer">
            <div className="consumption-item-title">精选办公电脑</div>
            <div className="consumption-item-btn" onClick={showZulin}>查看详情</div>
          </div>
        </div>
        <div className="consumption-footer">全行业全场景助你业务升级</div>
        <div className="consumption-footer-info">只要能租的行业/产品，我们都为你提供解决</div>
      </div>
      {/* 三大核心产品 */}
      <div className="product">
        <div className="product-title" style={{ cursor: "pointer" }}>
          三大核心产品
        </div>
        <hr className="hr-orange" />
        <div className="product-title-bottom">
          一站式、支付、流量、免押金风控、司法，你需要的我们都有
        </div>
        <div className="product-icon1" >
          <div className="product-icon-box" onMouseOver={() => setChannel(1)}>
            <div className={"product-icon-box-icon " + (channel === 1 ? "bussiness-active" : "bussiness")}></div>
            <div className="product-icon-box-name">商家入驻</div>
          </div>
          <div className="product-icon-box" onMouseOver={() => setChannel(2)}>
            <div className={"product-icon-box-icon " + (channel === 2 ? "mini-active" : "mini")}></div>
            <div className="product-icon-box-name">租赁小程序</div>
          </div>
          <div className="product-icon-box" onMouseOver={() => setChannel(3)}>
            <div className={"product-icon-box-icon " + (channel === 3 ? "open-active" : "open")}></div>
            <div className="product-icon-box-name">开放平台</div>
          </div>
        </div>
        <div className="product-content-store" id="storeContent" style={{ display: channel === 1 ? "block" : "none" }}>
          <div className="product-content-info" style={{padding:0}}>
            <span className="product-content-title">
              租赁商0元免费入驻
            </span>
            <ul className="product-contents">
              <li><div className="orangeCircle"></div> 0成本，1分钟免费快速开店</li>
              <li><div className="orangeCircle"></div> 线上，线下，微信，支付宝等流量全渠道通用</li>
              <li><div className="orangeCircle"></div> 导购选品，免押下单，租金扣款，逾期追款一站式闭环</li>
              <li><div className="orangeCircle"></div> 手机数码/母婴图书/服饰包箱/汽车电动车/美妆个护等全品类通用</li>
            </ul>
            <div className="product-button">
              <a className="product-button-left" href="#lianxi">
                <a href="#lianxi">免费试用</a>
              </a>
              <div className="product-button-right">
                <span onClick={changePages}>查看详情</span>
              </div>
            </div>
          </div>
        </div>
        <div className="product-content-store" style={{ display: channel === 2 ? "block" : "none" }} id="appContent">
          <div className="product-content-info">
            <span className="product-content-title">
              您自己的独立品牌
            </span>
            <ul className="product-contents">
              <li><div className="orangeCircle"></div> 基于云服务的支付宝小程序</li>
              <li><div className="orangeCircle"></div> 低成本享有租物流量红利</li>
              <li><div className="orangeCircle"></div> 无需自建研发团队，低成本快速拥有</li>
            </ul>
            <div className="product-button">
              <a className="product-button-left" href="#lianxi" >
                <a href="#lianxi">免费试用</a>
              </a>
              <div className="product-button-right">
                <span onClick={changePages}>查看详情</span>
              </div>
            </div>
          </div>
        </div>
        <div className="product-content-store" style={{ display: channel === 3 ? "block" : "none" }} id="openContent">
          <div className="product-content-info">
            <span className="product-content-title">
              更多功能供您使用
            </span>
            <ul className="product-contents">
              <li><div className="orangeCircle"></div> 多重技术能力输出</li>
              <li><div className="orangeCircle"></div> 有效赋能商家把控风险</li>
              <li><div className="orangeCircle"></div> 安全高效经营无忧</li>
            </ul>
            <div className="product-button">
              <div className="product-button-left" href="#lianxi" >
                <a href="#lianxi">免费试用</a>
              </div>
              <div className="product-button-right">
                <span onClick={changePages}>查看详情</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="box" id="business">
        <div className="box-title">全面构建租赁业务闭环</div>
        <div className="box-des">公私域引流、线上店铺、店铺营销、免押金<br />下单、租中租后管理、资产保障、全面构建租赁业务闭环</div>
        <div className="container">
          <div className="business-item" id="custom">
            <div className="business-item-title">获客</div>
            <div className="business-item-content">多维平台公域流量，多种私域赋能方案；助力商家业务增长</div>
            <div className="business-item-tag" id="blue">租赁前</div>
          </div>
          <div className="business-item" id="yajin">
            <div className="business-item-title">免押金</div>
            <div className="business-item-content">多维且全面的信用数据，经过时间验证的免押金风控方案</div>
            <div className="business-item-tag" id="blue">租赁前</div>
          </div>
          <div className="business-item" id="zujin">
            <div className="business-item-title">租金代扣</div>
            <div className="business-item-content">智能的通知提醒和资金代扣策略确保租金支付及时稳定</div>
            <div className="business-item-tag" id="red">租赁中</div>
          </div>
          <div className="business-item" id="zuwu">
            <div className="business-item-title">租物链</div>
            <div className="business-item-content">包含订单，电子合同，物流及签收存证等关键租物数据</div>
            <div className="business-item-tag" id="red">租赁中</div>
          </div>
          <div className="business-item" id="sifa">
            <div className="business-item-title">司法仲裁</div>
            <div className="business-item-content">一站式案件提交及管理流程，简单快捷</div>
            <div className="business-item-tag" id="green">租赁后</div>
          </div>
          <div className="business-item" id="shuju">
            <div className="business-item-title">数据分析</div>
            <div className="business-item-content">完美精准的数据处理，满足精细化业务管理需求</div>
            <div className="business-item-tag" id="green">租赁后</div>
          </div>
          <div className="btn-item">
            <div className="btn-item-title">公域流量引流，尽享业务增长</div>
            <div className="btn-item-sub">上传商品享受惠租千万用户流量红利，新店更有新店礼包，获得翻倍业务增长。</div>
            <div className="btn-item-btn" onClick={showAsk}>立即咨询</div>
          </div>
          <div className="btn-item">
            <div className="btn-item-title">0成本“一键开店”</div>
            <div className="btn-item-sub">助力行业增长，0成本即可开店；1分钟即可上传自己的商品店铺支持微信H5，支付宝小程序等多种形式助你获得全网流量，打造最佳用户体验。</div>
            <div className="btn-item-btn" onClick={showAsk}>立即咨询</div>
          </div>
        </div>
      </div>
              {/* 四重保障部分 */}
              <div className="guarantee">
          <div className="guarantee-title">
            惠租四重保障
          </div>
          <hr className="hr-orange" />
          <div className="guarantee-title-bottom">
            全方位为你的资产保驾护航
          </div>
          <div className="guarantee-content">
            <div className="guarantee-item">
              <img src='https://oss.huizustore.com/9594f53b75ae45a0931ea20013c691d1.png' alt="img" className="guarantee-item-img" />
              <div className="guarantee-item-detail">
                <div className="guarantee-item-detail-title">免押风控</div>
                <div className="guarantee-item-detail-info">接入支付宝信用支付体系，为用户减免押金的同时解决商户的发货信任问题。结合惠租自研红盾风控，提供超1000条风控信息及AI人工建议，快速甄别用户资质，把控风险，稳健经营。</div>
              </div>
            </div>
            <div className="guarantee-item">
              <img src='https://oss.huizustore.com/67090c8c5b324f3fa8debc4a429a5655.png' alt="img" className="guarantee-item-img" />
              <div className="guarantee-item-detail">
                <div className="guarantee-item-detail-title">司法仲裁</div>
                <div className="guarantee-item-detail-info">与仲裁委系统级对接，案件证据一键提交审理，从提交至判决低至一个月时间内;同时可采用法院强制执行，失信人等多维司法途径保障资产安全。</div>
              </div>
            </div>
            <div className="guarantee-item">
              <img src='https://oss.huizustore.com/a658e609a70f4f41bd624b866105782d.png' alt="img" className="guarantee-item-img" />
              <div className="guarantee-item-detail">
                <div className="guarantee-item-detail-title">区块链及保险</div>
                <div className="guarantee-item-detail-info">永久存证，不可篡改；可购买人保，财产损失后保险赔偿。</div>
              </div>
            </div>
            <div className="guarantee-item">
              <img src='https://oss.huizustore.com/fcd729e333fe4262bf060a50e337d37b.png' alt="img" className="guarantee-item-img" />
              <div className="guarantee-item-detail">
                <div className="guarantee-item-detail-title">锁机</div>
                <div className="guarantee-item-detail-info">惠租推出的苹果锁机服务，贴合商家痛点，针对性地解决手机租赁逾期坏账问题。</div>
              </div>
            </div>
          </div>
        </div>
      {/* <div className="box" id="shop">
        <div className="box-title">四步快速开店</div>
        <div className="box-des">一站式、支付、流量、免押金风控、司法，你需要的我们都有</div>
        <div className="container">
          <div className="shop-item">
            <img src="https://oss.huizustore.com/c9f5a13d9bd3498fa8c2580a040eb733.png" alt="img" className="shop-item-img" />
            <div className="shop-item-detail">
              <div className="shop-item-detail-title">1.确认营业执照</div>
              <div className="shop-item-detail-content">请先确认是否具备营业执照</div>
            </div>
          </div>
          <div className="shop-item">
            <img src="https://oss.huizustore.com/1187d4f71549490a8d129e22abace73f.png" alt="img" className="shop-item-img" />
            <div className="shop-item-detail">
              <div className="shop-item-detail-title">2.留下联系方式</div>
              <div className="shop-item-detail-content">为了方便取得联系，请确保您的手机保持畅通</div>
            </div>
          </div>
          <div className="shop-item">
            <img src="https://oss.huizustore.com/c9f5a13d9bd3498fa8c2580a040eb733.png" alt="img" className="shop-item-img" />
            <div className="shop-item-detail">
              <div className="shop-item-detail-title">3.客户经理沟通</div>
              <div className="shop-item-detail-content">24小时内客户经理会和您取得联系</div>
            </div>
          </div>
          <div className="shop-item">
            <img src="https://oss.huizustore.com/c9f5a13d9bd3498fa8c2580a040eb733.png" alt="img" className="shop-item-img" />
            <div className="shop-item-detail">
              <div className="shop-item-detail-title">4.平台开店成功</div>
              <div className="shop-item-detail-content">畅谈合作意向，助力开店成功</div>
            </div>
          </div>
        </div>
      </div> */}
      <div className="box" id="huizu">
        <div className="box-title">他们都在用惠租</div>
        <div className="box-des">排名不分先后顺序</div>
        <div className="list">
          <Swiper ref={listRef} defaultIndex={2} loop slideSize={60} indicator={() => null} trackOffset={20} stuckAtBoundary={false} allowTouchMove={false}>
            {
              list.map((item, index) => (
                <Swiper.Item key={index} style={{ display: 'flex', justifyContent: "center" }} >
                  <div className="list-item">
                    <img src={item.img} alt="" width={39} height={39} />
                    <div>
                      <div className="list-item-title">{item.title}</div>
                      <div className="list-item-content">{item.content}</div>
                    </div>
                  </div>
                </Swiper.Item>
              ))
            }
          </Swiper>
        </div>
        <div className="container">
          <div className="icon-left" onClick={() => {
            swiper.current.swipePrev()
            listRef.current.swipePrev()
          }}></div>
          <Swiper ref={swiper} loop indicator={() => null} allowTouchMove={false}>
            <Swiper.Item>

              <div className="huizu-item">
                <img src="https://oss.huizustore.com/1fab8a8fdb8f4637a3e0c043b0807eec.png" alt="" />
                <div className="detail">
                  <div className="huizu-item-title">大胜租赁</div>
                  <div className="huizu-item-tag">
                    <div className="huizu-item-tag-item">笔记本租赁</div>
                    <div className="huizu-item-tag-item">台式机租赁</div>
                    <div className="huizu-item-tag-item">企业租赁</div>
                  </div>
                  <div className="huizu-item-content">大胜租赁电脑店专注于电脑租赁服务，提供多种品牌和配置的电脑设备，满足办公、教育、娱乐等多领域需求。提供灵活的租赁期限和专业的技术支持，致力于为客户或企业提供最优质的电脑租赁体验。通过线上线下推广策略，大胜租赁电脑店年终用户累计超过1万+，累计下单量突破3万单。且在年末促销活动和企业需求的推动下，年度GMV稳步增长至450万元人民币。</div>
                  <div className="huizu-item-count">
                    <div className="huizu-item-count-item"><strong>10000</strong>+<br />用户数</div>
                    <div className="huizu-item-count-item"><strong>3000</strong>+<br />月度订单</div>
                  </div>
                </div>
              </div>
            </Swiper.Item>
            <Swiper.Item>
              <div className="huizu-item">
                <img src="https://oss.huizustore.com/b8c3f6d3ce254d6f95093d7f9de1e479.png" alt="" />
                <div className="detail">
                  <div className="huizu-item-title">基原租赁</div>
                  <div className="huizu-item-tag">
                    <div className="huizu-item-tag-item">平板租赁</div>
                    <div className="huizu-item-tag-item">二手平板全品类</div>
                    <div className="huizu-item-tag-item">优质商家</div>
                  </div>
                  <div className="huizu-item-content">槟恒贸易租赁店专注于手机租赁服务，提供最新款智能手机供您选择，并为您提供灵活的租赁期限和专业的技术支持。我们致力于为客户打造便捷、经济的手机使用体验。近一年来，基原租赁租赁的GMV增长势头强劲，从80万元人民币迅速增长至140万元人民币，增长率高达75%。这一成绩的背后，是对客户需求的深入洞察，以及对服务品质的持续追求。我们不断优化租赁流程，提升客户体验，赢得了广大客户的信赖与好评。</div>
                  <div className="huizu-item-count">
                    <div className="huizu-item-count-item"><strong>8000</strong>+<br />用户数</div>
                    <div className="huizu-item-count-item"><strong>1300</strong>+<br />月度订单</div>
                  </div>
                </div>
              </div>

            </Swiper.Item>
            <Swiper.Item>
              <div className="huizu-item">
                <img src="https://oss.huizustore.com/19dc37b582e94f0da9e32b3b7ce2b38d.png" alt="" />
                <div className="detail">
                  <div className="huizu-item-title">融易租数码</div>
                  <div className="huizu-item-tag">
                    <div className="huizu-item-tag-item">无人机租赁</div>
                    <div className="huizu-item-tag-item">年度高赞商家</div>
                    <div className="huizu-item-tag-item">优质商家</div>
                  </div>
                  <div className="huizu-item-content">融易租无人机租赁专注于为航拍爱好者、专业摄影师、入门新手等提供高效、可靠的无人机租赁服务。拥有多款先进的无人机设备，满足不同领域的租赁需求。在过去的一年里，翱翔无人机租赁的业务规模不断扩大，GMV也实现了令人瞩目的增长，从20万元人民币增长至65万元人民币，增长率高达225%。未来，融易租无人机租赁将继续秉持客户至上的原则，不断优化服务流程，提升客户满意度。</div>
                  <div className="huizu-item-count">
                    <div className="huizu-item-count-item"><strong>4000</strong>+<br />用户数</div>
                    <div className="huizu-item-count-item"><strong>4000</strong>+<br />月度订单</div>
                  </div>
                </div>
              </div>

            </Swiper.Item>
            <Swiper.Item>
              <div className="huizu-item">
                <img src="https://oss.huizustore.com/a912b93c574b411e93dcd96e50eb410d.png" alt="" />
                <div className="detail">
                  <div className="huizu-item-title">趣智数码</div>
                  <div className="huizu-item-tag">
                    <div className="huizu-item-tag-item">全品类相机</div>
                    <div className="huizu-item-tag-item">镜头租赁</div>
                    <div className="huizu-item-tag-item">优质商家</div>
                  </div>
                  <div className="huizu-item-content">趣智数码相机租赁专注于入门及高端相机租赁服务，拥有丰富的相机型号和专业的租赁方案，满足不同摄影爱好者的需求。趣智数码相机租赁近年来业务规模不断扩大，租赁设备种类和数量持续增长。近一年，我们的GMV实现了显著增长，从35万元人民币增长至86万元人民币，增长率高达145%。这一增长主要得益于我们与各大相机供应商的紧密合作，确保了租赁设备的库存品质和多样性。同时，我们不断优化租赁策略和服务流程，提高了客户满意度和复购率，进一步推动了GMV的增长。</div>
                  <div className="huizu-item-count">
                    <div className="huizu-item-count-item"><strong>5000</strong>+<br />用户数</div>
                    <div className="huizu-item-count-item"><strong>800</strong>+<br />月度订单</div>
                  </div>
                </div>
              </div>

            </Swiper.Item>
            <Swiper.Item>
              <div className="huizu-item">
                <img src="https://oss.huizustore.com/4660179aca7a45b0927a2b85aac0b00c.png" alt="" />
                <div className="detail">
                  <div className="huizu-item-title">槟恒贸易</div>
                  <div className="huizu-item-tag">
                    <div className="huizu-item-tag-item">手机租赁</div>
                    <div className="huizu-item-tag-item">手表租赁</div>
                    <div className="huizu-item-tag-item">优质商家</div>
                  </div>
                  <div className="huizu-item-content">槟恒贸易租赁店专注于手机租赁服务，提供最新款智能手机供您选择，并为您提供灵活的租赁期限和专业的技术支持。我们致力于为客户打造便捷、经济的手机使用体验。近一年，槟恒贸易手机租赁店的GMV实现了1000%的快速增长，年度发货GMV4000万元。这主要得益于我们不断优化服务流程、提升客户满意度以及推出具有竞争力的租赁策略。我们与各大手机品牌建立了紧密的合作关系，确保提供的手机设备均为最新款、高品质的产品。</div>
                  <div className="huizu-item-count">
                    <div className="huizu-item-count-item"><strong>30000</strong>+<br />用户数</div>
                    <div className="huizu-item-count-item"><strong>8000</strong>+<br />月度订单</div>
                  </div>
                </div>
              </div>
            </Swiper.Item>
          </Swiper>
          <div className="icon-right" onClick={() => {
            swiper.current.swipeNext()
            listRef.current.swipeNext()
          }}></div>

        </div>

      </div>
      <div className="box" id="comit">
        <div className="box-title">立即扫码咨询</div>
        <div className="box-des">领取您的专属解决方案</div>
        <div className="container">
          <div className="img-box">
            <img src="https://oss.huizustore.com/3ab3ba5267ca4fd688efe739112943ce.png" alt="img" className="img" />
          </div>
          <div className="title">马上扫码添加客户经理</div>
          <div className="sub">或者您也可以先试用</div>
          <div className="btn" onClick={showModal}>免费试用</div>
        </div>
      </div>
    </div>
  )
}

export default Business;